import { render, staticRenderFns } from "./EditAddressesStockBtn.vue?vue&type=template&id=f880eb3e&"
import script from "./EditAddressesStockBtn.vue?vue&type=script&lang=js&"
export * from "./EditAddressesStockBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports